import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";

class SendFromMyConsultationsStrategy extends BaseSendToPortalPopupStrategy {
    protected portalLinkedItemType: PortalLinkedItemType;

    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = 0;

    public get shouldShowFilePreview(): boolean {
        return false;
    }

    constructor(model: IPortalLinkedItemModel) {
        super(
            model.get("LinkedItemType"),
            LocalOperations.Portfolio.MyConsultationRequests_SendToPortal_RevokeClick,
            LocalOperations.Portfolio.MyConsultationRequests_SendToPortal_CancelClick
        );

        this.portalLinkedItemType = model.get("LinkedItemType");
    }

    public onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): void {
        sessionStore.dispatch(
            LocalOperations.Portfolio.MyConsultationRequests_SendToPortal_SyncClick,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument,
                priority: priority,
                canPatientReplyWithMessage: canPatientReplyWithMessage
            }
        );
    }
}

export { SendFromMyConsultationsStrategy };
